import React from "react";
// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";

import Section1 from "../includes/OffshoreDevelopment/Section1";
import Section2 from "../includes/OffshoreDevelopment/Section2";
import Section3 from "../includes/OffshoreDevelopment/Section3";
import Section4 from "../includes/OffshoreDevelopment/Section4";
import Section5 from "../includes/OffshoreDevelopment/Section5";
import Section6 from "../includes/OffshoreDevelopment/Section6";
import Section7 from "../includes/OffshoreDevelopment/Section7";
import Section8 from "../includes/OffshoreDevelopment/Section8";

// form from homepage
import Section9 from "../includes/Home/Section9";

const OffshoreDevelopment = ({ devUrl }) => {

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Service",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.exddigital.com/offshore-software-development",
    },
    name: "Offshore Software Development Services",
    headline: "Scale Your Engineering Team with Reliable Offshore Development",
    description:
      "Build and scale high-quality software with dedicated offshore development teams. We provide reliable, cost-efficient engineering support tailored to your business.",
    image: "https://www.exddigital.com/images/exd_digital.webp",
    provider: {
      "@type": "Organization",
      name: "ExD Digital",
      url: "https://www.exddigital.com",
    },
    areaServed: "Worldwide",
    datePublished: "2026-04-21",
    dateModified: "2026-04-21",
  };

  return (
    <>
      <Helmet>
        <title>Offshore Software Development Services</title>

        <meta
          name="description"
          content="Hire dedicated offshore developers and scale your engineering team with reliable, cost-effective software development services."
        />

        <link
          rel="canonical"
          href="https://www.exddigital.com/offshore-software-development"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Offshore Software Development Services | ExD Digital"
        />
        <meta
          property="og:description"
          content="Scale your team with dedicated offshore developers. Build, extend, and maintain software with reliable global engineering support."
        />
        <meta
          property="og:url"
          content="https://www.exddigital.com/offshore-software-development"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Offshore Software Development Services | ExD Digital"
        />
        <meta
          name="twitter:description"
          content="Hire offshore developers to scale your team with high-quality, cost-efficient software development."
        />
        <meta
          name="twitter:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        {/* Schema */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>

      <main className="our-ai-main">
        <article className="offshore-development">

          <Section1 url={devUrl} />
          <Section2 url={devUrl} />
          <Section3 url={devUrl} />
          <Section4 url={devUrl} />
          <Section5 url={devUrl} />
          <Section6 url={devUrl} />
          <Section7 url={devUrl} />
          <Section8 url={devUrl} />
          <Section9 url={devUrl} />

        </article>
      </main>
    </>
  );
};

export default OffshoreDevelopment;